import axios from 'axios'
import {MessageBox} from 'element-ui'
import router from '@/router/index'
import store from '../store/index.js'

export const base_url =  process.env.API_BASE_URL
const service = axios.create()
// export const myGetData = url => 
//   service({
//     url:url,
//     method: 'get'
//   })
export const myGet = url => 
  service({
    url: base_url + url,
    method: 'get'
  })
export const myPost = (url,data) => 
  service({
    url: base_url + url,
    method: 'post',
    data
  })

  export const myDelete = url => 
  service({
    url: base_url + url,
    method: 'delete',
  })
  
export const myPostText = (url, data) =>
  service({
    url: base_url + url,
    method: 'post',
    headers: {
      'Content-Type': 'text/html'
    },
    data
  })
  
export const exportExcel = (url,data) => 
  service({
    url: base_url + url,
    method: 'post',
    responseType: 'blob',
    data
  })


  export const exportCode = (url,data) => 
  service({
    url: base_url + url,
    method: 'get',
    responseType: 'arraybuffer',
    headers: { 
      'codetoken': 111,     
    },
    data
  })
  export const getcode = (url,data) => exportCode(url,data)
      service.interceptors.response.use(function (response){
            // console.log(response);
            return response;
      },function (error) {
        return Promise.reject(error)
      }
  )


  export const done = (url,data) => axios.post(base_url+url,data)
  service.interceptors.request.use(
      req => {
        // console.log(req);
        return req
      },
      error => {
        // Do something with request error
        Promise.reject(error)
      }
  )



export const login = (url,data) => axios.post(base_url + url,data)
service.interceptors.request.use(
    config => {
      // const myToken = localStorage.getExpire('Token')
      const myLang = localStorage.getExpire('Lang')
      const siteId = localStorage.getItem("siteId")
      // if (myToken) {
  
      //   config.headers['Token'] = myToken // 让每个请求携带自定义token
      // }
      if (myLang) {
        config.headers['Lang'] = myLang // 让每个请求头携带语言类型
      }
      if (siteId) {
        config.headers['SiteId'] = siteId // 让每个请求头携带语言类型
      }
      return config
    },
    error => {
      // Do something with request error
      Promise.reject(error)
    }
)
service.interceptors.response.use(
  response => {
    // sessionStorage.setItem("key", "once");
    // console.log(response)
    if(response.headers.code == 501) {
      MessageBox.alert('禁止访问网页，如有问题请联系4006-515-848', '警告', {
        confirmButtonClass: "el-button--primary",
        // confirmButtonText: '确定',
        showClose:false,
        lockScroll:true,
        showConfirmButton:false,
        type: "warning",
      })
    }
    // console.log(response.headers.code)
    if(response.data.code!=200){
      if(response.data.code == 401) {
        if(localStorage.getExpire('justOnce')) {
          MessageBox.alert('您尚未登录或登录已过期，请重新登录！','提醒',{
            confirmButtonClass: "el-button--primary",
            type: "warning"
          })
          .then(()=>{
            localStorage.setExpire('justOnce',false)
            // router.push({ path: '/home'})
            let timeId = setTimeout(()=>{
              localStorage.setExpire('justOnce',true)
              clearTimeout(timeId)
            },2000) 
          })
        }       
      }
      else if(response.data.code == 403) {
        // console.log(sessionStorage.getItem("key"))
        // store.commit('changeOnce', 'false')
        console.log(store.state.once)
        // store.commit('changeOnce', 'false')
        if(localStorage.getExpire('justOnce') && store.state.once == true) {
          store.commit('changeOnce', 'false')
          MessageBox.alert('您没有访问权限！','提醒',{
            confirmButtonClass: "el-button--primary",
            type: "warning"
          })
          router.push({ path: '/'})
          .then(()=>{
            
            sessionStorage.setItem("key", "once")
            localStorage.setExpire('justOnce',false)
            let timeId = setTimeout(()=>{
              localStorage.setExpire('justOnce',true)
              clearTimeout(timeId)
            },2000) 
          })

        }  
        // return Promise.reject('error')
      }
      else if(response.data.code == 404) {
        MessageBox.alert('访问失败，请检查网络')
      }
      else if(response.data.code === undefined) {
        return response
      }
      else if(response.data.code == 501) {
        MessageBox.alert('禁止访问网页，如有问题请联系4006-515-848', '警告', {
          confirmButtonClass: "el-button--primary",
          // confirmButtonText: '确定',
          showClose:false,
          lockScroll:true,
          showConfirmButton:false,
          type: "warning",
        })
      }
      else {
        // if(store.state.once == true) {
        MessageBox.alert(response.data.message,'警告',{
          confirmButtonClass: "el-button--primary",
          type: "warning"
        })

        // store.commit('changeOnce', 'false')
      }
      // }
      return Promise.reject('error')
    }
    else {
      // console.log(response)
      return response
    }
  },
  error => {
    return Promise.reject(error)
  }
)


// WEBPACK FOOTER //
// ./src/api/http.js